import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export const useFetchUserList = () => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    response,
    request,
    error,
  } = useQuery(() => api.admin.fetchApps())

  useEffect(() => {
    request()
  }, [])

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  return {
    fetchAppList: request,
    isLoadingFetchAppList: isLoading,
    dataAppList: response?.list
  }
}
